export const bugReportGuide = {
  title: 'How to report a bug with a screen recording',
  slug: 'how-to-report-a-bug-with-a-screen-recording',
  date: '2026-09-30',
  description: 'Record a browser bug, point to the moment that matters, add the context a video cannot show, and repeat the same flow after a fix.',
} as const;
